import {connect} from 'react-redux'
import PartImage from 'components/partImage'
import {removePartImage, uploadPartImage} from 'actions/priceLists'
import {get} from 'lodash'

const mapStateToProps = (state, ownProps) => {
  const partId = get(ownProps, 'part.id', null)
  const imageDates = state.priceListsContext.partImageDates
  return {
    lastUpdated: imageDates[partId] || imageDates.default,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const partId = get(ownProps, 'part.id', null)
  return {
    onUpload: (file) => dispatch(uploadPartImage(partId, file)),
    onRemove: () => dispatch(removePartImage(partId)),
  }
}

const PartImageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PartImage)

export default PartImageContainer